import { AsyncThunk, createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { filterDataAPIv1 } from "services/CRUDServices"
import { filterUrls } from "services/api.enums"

export const filterCRMConsignment: AsyncThunk<{}, {}, {}> = createAsyncThunk(
  "crm-consignment",
  async (body: any) => {
    let { data } = await filterDataAPIv1(
      filterUrls.CRMConsignment,
      {
        ...body,
        pageNumber: undefined,
        pageSize: undefined,
      },
      body.pageNumber,
      body.pageSize,
      [
        {
          property: "createdDate",
          direction: "DESC",
        },
      ]
    )

    return data.response
  }
)

const initialState: any = {
  crmConsignmentData: [],
  fetchpost: false,
  errorMessage: null,
  isUpdating: false,
  filter: {},
}

const CRMConsignmentDataSlice = createSlice({
  initialState: initialState,
  name: "crm-consignment",
  reducers: {
    clearCRMConsignmentData: (state) => {
      state.crmConsignmentData = []
    },
    setFilterCRMConsignment: (state, action) => {
      state.filter = action.payload
    },
  },
  extraReducers: {
    [filterCRMConsignment.fulfilled as any]: (state, action) => {
      state.crmConsignmentData = action.payload
      state.fetchPost = false
    },
    [filterCRMConsignment.pending as any]: (state) => {
      state.fetchPost = true
    },
    [filterCRMConsignment.rejected as any]: (state) => {
      state.fetchPost = false
      state.errorMessage = "wrong"
    },
  },
})

export const { setFilterCRMConsignment, clearCRMConsignmentData } =
  CRMConsignmentDataSlice.actions

export default CRMConsignmentDataSlice.reducer
